import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { toast } from "react-toastify";
import {
  MdKeyboardDoubleArrowRight,
  MdKeyboardDoubleArrowLeft,
} from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import {
  FaUser,
  FaRegListAlt,
  FaUsers,
  FaUsersSlash,
  FaMoneyBillAlt,
  FaUserPlus,
  FaClipboardList,
  FaChartLine,
  FaWhatsappSquare,
  FaPhoneAlt,
  FaWhatsapp,
  FaUserCircle,
  FaRegEdit,
} from "react-icons/fa"; // Add the icons you need
import { FaClock } from "react-icons/fa6";
import {
  RiPassPendingFill,
  RiFolderUploadFill,
  RiQrCodeFill,
  RiBuilding4Fill,
  RiLogoutCircleRLine,
} from "react-icons/ri";
import { CgGym, CgProfile } from "react-icons/cg";
import { MdAccountBalance, MdQrCode2, MdManageAccounts } from "react-icons/md";

import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../slices/gymSlice";
import { logout } from "../slices/authSlice";
import { removeUsers } from "../slices/userSlice";

import { removeAttendances } from "../slices/attendanceListSlice";
import { removeSelfUsers } from "../slices/userSelfSlice";
import preferredLanguage from "../assets/preferredLanguage.json";

const HeaderLeft = function ({ leftMenuOpen, setExpandMenu }) {
  const { userInfo } = useSelector((state) => state.auth);

  const selectedLanguage = userInfo?.preferredLanguage
    ? userInfo?.preferredLanguage
    : "English";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApi] = useLogoutMutation();
  let gymId;
  if (userInfo) {
    gymId = userInfo.gymId._id;
  }
  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();
      dispatch(logout());
      dispatch(removeUsers());
      dispatch(removeAttendances());
      dispatch(removeSelfUsers());
      navigate("/login");
      toast.success("Successfully logged out");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <header
      style={{
        position: "sticky",
        top: "0px",
        zIndex: 1,
      }}
      className={`${userInfo?.themeColor}ThemeHeaderTop`}
    >
      {userInfo ? (
        <>
          <Navbar
            style={{
              backgroundColor: "inherit", // Use any hex color code
              color: "#ffffff", // Set the text color
              height: "40px",
              marginTop: "0.2px",
            }}
          >
            <Container
              style={{
                backgroundColor: "inherit", // Use any hex color code
                color: "#ffffff", // Set the text color
                height: "40px",
                marginTop: "0.2px",
              }}
            >
              <LinkContainer to="/markAttendance">
                <Navbar.Brand>
                  {/* <img src={logo} alt="zpotter"></img>{" "} */}
                  {/* <label style={{ fontSize: "1.5rem" }}>ZPOTTER</label> */}
                  zpotter
                </Navbar.Brand>
              </LinkContainer>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <label style={{ fontSize: "1.5rem" }}>
                  {" "}
                  {userInfo ? userInfo?.gymId?.name : "Zpotter"}
                </label>
              </div>
              {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav"> */}
              <Nav
                className="ms-auto"
                style={{
                  backgroundColor: "inherit",
                  color: "#ffffff",
                }}
              >
                {userInfo ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: "10",
                        width: "100%",
                      }}
                    >
                      <FaUserCircle style={{ marginRight: "3px" }} />
                    </div>

                    <NavDropdown
                      title={userInfo.firstName}
                      style={{ marginRight: "90px" }}
                    >
                      <LinkContainer to="/profile">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {preferredLanguage[selectedLanguage]?.myProfile}
                        </NavDropdown.Item>
                      </LinkContainer>
                      {userInfo.role === "owner" ||
                      userInfo.role === "Super Admin" ? (
                        <>
                          <LinkContainer to="/gymProfile">
                            <NavDropdown.Item>
                              {" "}
                              <RiBuilding4Fill style={{ marginRight: "3px" }} />
                              {preferredLanguage[selectedLanguage]?.gymProfile}
                            </NavDropdown.Item>
                          </LinkContainer>
                          <LinkContainer to="/updateAttendancePageScreen">
                            <NavDropdown.Item>
                              <FaRegEdit style={{ marginRight: "3px" }} />
                              {preferredLanguage[selectedLanguage]?.editAttPage}
                            </NavDropdown.Item>
                          </LinkContainer>
                        </>
                      ) : (
                        <></>
                      )}
                      <LinkContainer to="/qrCode">
                        <NavDropdown.Item>
                          <MdQrCode2 style={{ marginRight: "2px" }} />
                          {
                            preferredLanguage[selectedLanguage]
                              ?.attendanceQrCode
                          }
                        </NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/qrcodeRegister">
                        <NavDropdown.Item>
                          <RiQrCodeFill style={{ marginRight: "2px" }} />
                          {preferredLanguage[selectedLanguage]?.regQrCode}
                        </NavDropdown.Item>
                      </LinkContainer>

                      <LinkContainer to="/contactUs">
                        <NavDropdown.Item>
                          {" "}
                          <FaPhoneAlt style={{ marginRight: "2px" }} />
                          Contact Us
                        </NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Item onClick={handleLogout}>
                        <RiLogoutCircleRLine style={{ marginRight: "3px" }} />
                        Logout
                      </NavDropdown.Item>
                    </NavDropdown>
                  </>
                ) : (
                  <LinkContainer to="/login">
                    <Nav.Link>
                      <FaUser />
                      Login
                    </Nav.Link>
                  </LinkContainer>
                )}
              </Nav>
              {/* </Navbar.Collapse> */}
            </Container>
          </Navbar>
          {leftMenuOpen ? (
            <aside
              className={`${userInfo.themeColor}ThemeHeaderLeft`}
              style={{
                width: leftMenuOpen ? "270px" : "45px", // Adjust width as needed
                // display: "none",
                height: "100vh", // Full viewport height
                position: "fixed", // Keep it fixed on the left
                top: "40px",
                left: "0",

                padding: "20px",
                overflowY: "auto", // Allow scrolling for long content
              }}
            >
              <div>
                {leftMenuOpen && (
                  <button
                    style={{
                      backgroundColor: "orange",
                      border: "none",
                      padding: "10px",
                      color: "white",
                      cursor: "pointer",
                      borderRadius: "5px",
                      // Align the button to the right
                      marginBottom: "3px", // Add some spacing
                    }}
                    onClick={(e) => setExpandMenu(false)}
                  >
                    <MdKeyboardDoubleArrowLeft style={{ marginRight: "2px" }} />{" "}
                    Hide Menu
                  </button>
                )}
              </div>
              <Navbar
                style={{
                  backgroundColor: "inherit", // Use any hex color code
                  color: "#ffffff", // Set the text color
                  marginTop: "0.2px",
                  height: "100%",
                  flexDirection: "column",
                }}
                expand="md"
                collapseOnSelect
              >
                <Container
                  style={{
                    backgroundColor: "inherit", // Use any hex color code
                    color: "#ffffff", // Set the text color
                    marginTop: "0.2px",
                  }}
                >
                  {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav"> */}
                  <Nav
                    className="flex-column"
                    style={{
                      backgroundColor: "inherit",
                      color: "#ffffff",
                      alignItems: "left",
                    }}
                  >
                    <Nav.Link
                      href="https://mytime.zpotter.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaClock style={{ marginRight: "2px" }} />
                      {preferredLanguage[selectedLanguage]?.attendance}
                    </Nav.Link>
                    {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ? (
                      <LinkContainer to="/trends">
                        <Nav.Link>
                          {" "}
                          <FaUserPlus style={{ marginRight: "2px" }} />
                          {
                            preferredLanguage[selectedLanguage]?.attendancePage
                              .todaysTrend
                          }
                        </Nav.Link>
                      </LinkContainer>
                    ) : (
                      <></>
                    )}

                    <LinkContainer to="/userRegistration">
                      <Nav.Link>
                        {" "}
                        <FaUserPlus style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.userReg}
                      </Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/attendanceList">
                      <Nav.Link>
                        {" "}
                        <FaClipboardList style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.attendanceList}
                      </Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/visitors">
                      <Nav.Link>
                        {" "}
                        <FaRegListAlt style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.visitors}
                      </Nav.Link>
                    </LinkContainer>
                    <hr style={{ border: "1px solid #ccc", margin: "5px 0" }} />
                    <LinkContainer to="/allUsers">
                      <Nav.Link>
                        <FaUsers style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.allMembers}
                      </Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/users">
                      <Nav.Link>
                        <FaUsers style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.activeMember}
                      </Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/subsExpiredUsers">
                      <Nav.Link>
                        <FaUsersSlash style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.inActiveMembers}
                      </Nav.Link>
                    </LinkContainer>
                    {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ? (
                      <LinkContainer to="/payments">
                        <Nav.Link>
                          <FaMoneyBillAlt style={{ marginRight: "2px" }} />
                          {preferredLanguage[selectedLanguage]?.paymentsList}
                        </Nav.Link>
                      </LinkContainer>
                    ) : (
                      <></>
                    )}

                    <LinkContainer to="/regPendingUsers">
                      <Nav.Link>
                        <RiPassPendingFill style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.pendingReg}
                      </Nav.Link>
                    </LinkContainer>
                    {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ||
                    userInfo.role === "Admin" ? (
                      <>
                        {" "}
                        <LinkContainer to="/uploadUsers">
                          <Nav.Link>
                            <RiFolderUploadFill
                              style={{ marginRight: "2px" }}
                            />
                            {preferredLanguage[selectedLanguage]?.bulkUpload}
                          </Nav.Link>
                        </LinkContainer>
                      </>
                    ) : (
                      ""
                    )}
                    <hr style={{ border: "1px solid #ccc", margin: "5px 0" }} />
                    {userInfo ? (
                      <>
                        {" "}
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ||
                        userInfo.role === "Admin" ? (
                          <LinkContainer to="/equipments">
                            <Nav.Link>
                              {" "}
                              <CgGym style={{ marginRight: "2px" }} />
                              {
                                preferredLanguage[selectedLanguage]
                                  ?.equipmentManagement
                              }
                            </Nav.Link>
                          </LinkContainer>
                        ) : (
                          <></>
                        )}
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ? (
                          <>
                            {gymId ? (
                              <LinkContainer to="/accounts">
                                <Nav.Link>
                                  {" "}
                                  <MdAccountBalance
                                    style={{ marginRight: "2px" }}
                                  />
                                  {
                                    preferredLanguage[selectedLanguage]
                                      ?.accounts
                                  }
                                </Nav.Link>
                              </LinkContainer>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                        <LinkContainer to="/associatesAttendance">
                          <Nav.Link>
                            {" "}
                            <MdManageAccounts style={{ marginRight: "2px" }} />
                            {
                              preferredLanguage[selectedLanguage]
                                ?.associateAttendanceList
                            }
                          </Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/associates">
                          <Nav.Link>
                            {" "}
                            <MdManageAccounts style={{ marginRight: "2px" }} />
                            {
                              preferredLanguage[selectedLanguage]
                                ?.adminManagement
                            }
                          </Nav.Link>
                        </LinkContainer>
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ||
                        userInfo.role === "Admin" ? (
                          <LinkContainer to="/dashboard">
                            <Nav.Link>
                              <FaChartLine style={{ marginRight: "2px" }} />
                              {preferredLanguage[selectedLanguage]?.analytics}
                            </Nav.Link>
                          </LinkContainer>
                        ) : (
                          <></>
                        )}
                        {/* <LinkContainer to="/usersAtGym/896041834487">
                      <NavDropdown.Item>Numbers to Users</NavDropdown.Item>
                    </LinkContainer> */}
                        <hr
                          style={{
                            border: "1px solid #ccc",
                            margin: "5px 0",
                          }}
                        />
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ? (
                          <LinkContainer to="/promotionalMessage">
                            <Nav.Link>
                              {" "}
                              <FaWhatsapp style={{ marginRight: "2px" }} />
                              {preferredLanguage[selectedLanguage]?.sendAds}
                            </Nav.Link>
                          </LinkContainer>
                        ) : (
                          <></>
                        )}
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ||
                        userInfo.role === "Admin" ? (
                          <LinkContainer to="/whatsAppMessages">
                            <Nav.Link>
                              {" "}
                              <FaWhatsappSquare
                                style={{ marginRight: "2px" }}
                              />
                              {
                                preferredLanguage[selectedLanguage]
                                  ?.wsNotification
                              }
                            </Nav.Link>
                          </LinkContainer>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <LinkContainer to="/login">
                        <Nav.Link>
                          <FaUser />
                          {preferredLanguage[selectedLanguage]?.login}
                        </Nav.Link>
                      </LinkContainer>
                    )}
                  </Nav>
                  {/* </Navbar.Collapse> */}
                </Container>
              </Navbar>
            </aside>
          ) : (
            <aside
              className={`${userInfo.themeColor}ThemeHeaderLeft`}
              style={{
                width: leftMenuOpen ? "250px" : "45px", // Adjust width as needed
                // display: "none",
                height: "100vh", // Full viewport height
                position: "fixed", // Keep it fixed on the left
                top: "40px",
                left: "0",

                padding: "4px",
                overflowY: "auto", // Allow scrolling for long content
              }}
            >
              <div>
                {!leftMenuOpen && (
                  <button
                    style={{
                      backgroundColor: "orange",
                      border: "none",
                      padding: "10px",
                      color: "white",
                      cursor: "pointer",
                      // Align the button to the right
                      marginBottom: "3px", // Add some spacing
                    }}
                    onClick={(e) => setExpandMenu(true)}
                  >
                    <GiHamburgerMenu style={{ marginRight: "2px" }} />
                  </button>
                )}
              </div>
            </aside>
          )}
        </>
      ) : (
        <></>
      )}
    </header>
  );
};

export default HeaderLeft;
